<div
    *ngFor="let key of validationMessageKeys"
    class="validation-message-item"
    [class.valid]=" control.isDirtyOrTouched && !control.formControl.errors?.[key]"
>
    <span class="validation-message-item-bullet"></span>
    <span class="validation-message-text">{{ validationMessages[key] }}</span>
</div>
